import { useContext, useEffect, useState } from "react";
import { Screen } from "../../../main/components/screen/Screen";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import { MainContext } from "../../../main/context/MainContextProvider";
import { usinasApi } from "../../../services/api";
import { ErrorModal } from "../../../main/components/ErrorModal";
import { NotFoundError } from "../../../errors";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import DatePickerLocalizationAdapter from "../../../main/context/DatePickerLocalizationAdapter";
import { useNavigate } from "react-router-dom";
import { getMonthName } from "../../dashboard/helpers/format-number";
import CardBox from "../../../main/components/CardBox";
import {
  formatDateAndHour,
  numberPtBr,
  numberPtBrPercent01,
} from "../../../main/utils/utils";
import { UsinaDetailsCard, UsinaDetailsInfo } from "./ReportDaily";
import PRPerformedAndIrradiationChart from "../components/report_cards/PRPerformedAndIrradiationChart";
import PerformanceTable from "../components/report_cards/PerformanceTable";
import GeneratedEnergyCharts from "../components/report_cards/GeneratedEnergyCharts";
import InverterPerformanceCard from "../components/report_cards/InverterPerformanceChart";
import UnitPerformanceChart from "../components/report_cards/UnitPerformanceChart";
import ParetoReportChart from "../components/report_cards/ParetoReportChart";
import ParetoTable from "../components/report_cards/ParetoTable";
import GeneratedParetoCharts from "../components/report_cards/GeneratedPateroCharts";
import ExpectedAndGeneratedValueChart from "../components/report_cards/ExpectedAndGeneratedValueChart";
import GenerationComparisonChart from "../components/report_cards/GenerationComparisonChart";
import PerformanceRatioChart from "../components/report_cards/PerformanceRatioChart";
import LossDiagramReportChart from "../components/report_cards/LossDiagramReportChart";
import GeneratedAvailabilityCharts from "../components/report_cards/GeneratedAvailabilityChart";
import MTTRAndMTBFChart from "../../dashboard/components/MTTRAndMTBFChart";
import { Usina } from "../types";

export default function ReportMonth() {
  const {
    selectedDashboardUsina: selectedUsina,
    // toastNotifications,
    // setToastNotifications,
    // relatorioMensalLoading,
    relatorioMensal,
    // setRelatorioMensalLoading,
    // setRelatorioMensal,
    theme
  } = useContext(MainContext);

  const primary = theme.muiTheme.palette.primary.main;

  const [isLoadingMonthlyReport, setIsLoadingMonthlyReport] =
    useState<boolean>(false);

  const [reportMonthandYear, setReportMonthandYear] = useState<{
    month: number;
    year: number;
  }>({
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  });

  const reportMonthDate = dayjs(
    new Date(reportMonthandYear.year, reportMonthandYear.month)
  );

  const [errorModalData, setErrorModalData] = useState<{
    title: string;
    message: string;
  }>({ title: "", message: "" });

  const handleGetMonthlyReport = async () => {
    setIsLoadingMonthlyReport(true);
    try {
      const reportMonth = reportMonthandYear.month + 1;
      const pdfResponse = await usinasApi.getMonthlyReportUsina(
        reportMonth,
        reportMonthandYear.year,
        selectedUsina?.usinaIds.id ?? ""
      );
      // Download by creating a link and clicking it to work on all browsers

      const downloadButton = document.createElement("a");
      downloadButton.href = pdfResponse.data.url;
      downloadButton.download = `relatorio-mensal-${reportMonthandYear.year
        }-${reportMonth.toString().padStart(2, "0")}.pdf`;
      downloadButton.click();
    } catch (error) {
      if (error instanceof NotFoundError) {
        setErrorModalData({
          title: "Relatório não encontrado",
          message: `O relatório do mês ${(reportMonthandYear.month + 1)
            .toString()
            .padStart(2, "0")}/${reportMonthandYear.year} não está disponível.`,
        });
        return;
      }
      setErrorModalData({
        title: "Erro ao buscar pdf",
        message: "Ocorreu um erro ao buscar o pdf, tente novamente.",
      });
    } finally {
      setIsLoadingMonthlyReport(false);
    }
  };

  const closeErrorModal = (open: boolean) => {
    !open && setErrorModalData({ title: "", message: "" });
  };
  const showErrorModal = errorModalData.title !== "";

  const today = dayjs(new Date());

  const [reportDate, setReportDate] = useState<string>(
    new Date().toISOString().split("T")[0]
  );
  // const [reportErrors, setReportErrors] = useState<string[]>([]);

  const navigate = useNavigate();

  // const getRelatorioMensal = async () => {
  //   setRelatorioMensalLoading(true);
  //   const newNotifications = {
  //     isAdding: true,
  //     notifications: [
  //       ...toastNotifications.notifications,
  //       {
  //         severity: "info" as const,
  //         text: "A busca foi inicializada, voce será notificado assim que ela for finalizada!",
  //       },
  //     ],
  //   };
  //   setToastNotifications(newNotifications);
  //   try {
  //     const reportMonth = reportMonthandYear.month + 1;
  //     const reportMothlyResponse = await usinasApi.getMonthlyReportInfoUsina(
  //       reportMonth,
  //       reportMonthandYear.year,
  //       selectedUsina?.usinaIds.id ?? ""
  //     );

  //     setRelatorioMensal(reportMothlyResponse.data.relatorioMensal);
  //     setReportErrors(reportMothlyResponse.data.errors);
  //     const newNotifications = {
  //       isAdding: true,
  //       notifications: [
  //         ...toastNotifications.notifications,
  //         {
  //           severity: "success" as const,
  //           text: (
  //             <>
  //               Relatório mensal gerado com sucesso!{" "}
  //               <a
  //                 style={{ cursor: "pointer" }}
  //                 onClick={() => navigate("/usinas/boletim-mensal")}
  //               >
  //                 Clique aqui
  //               </a>{" "}
  //               para vizualizar.
  //             </>
  //           ),
  //         },
  //       ],
  //     };
  //     setToastNotifications(newNotifications);
  //   } catch (error) {
  //     const newNotifications = {
  //       isAdding: true,
  //       notifications: [
  //         ...toastNotifications.notifications,
  //         {
  //           severity: "error" as const,
  //           text: "Erro ao gerar relatório mensal, tente novamente!",
  //         },
  //       ],
  //     };
  //     setToastNotifications(newNotifications);
  //   } finally {
  //     setRelatorioMensalLoading(false);
  //   }
  // };

  const [currentUsina, setCurrentUsina] = useState<Usina>();

  const getUsina = async (selectedUsinaId: string) => {
    try {
      if (!selectedUsinaId) return;
      const reportDailyResponse = await usinasApi.getUsina(
        selectedUsinaId
      )
      setCurrentUsina(reportDailyResponse)
    } catch {
      console.error(`Houve um erro inesperado ao tentar buscar os detalhes da usina ${selectedUsina?.name}`)
    }
  }

  useEffect(() => {
    getUsina(selectedUsina?.usinaIds.id ?? "")
  }, [selectedUsina])

  const getExportButtonTooltipText = (usinaHasPermission: boolean | null | undefined, usinaId: string | undefined): React.ReactNode => {

    if (!usinaHasPermission) {
      return <>A usina não tem permissão para relatório mensal, <Box sx={{ cursor: "pointer", color: primary }} onClick={() => navigate(`/usinas/${usinaId}`)}>Clique aqui para alterar a permissão da usina</Box></>
    }

    if (isLoadingMonthlyReport) return "Aguarde a exportação do relatório mensal."

    if (!reportDate) return "Selecione uma data para geração de relatório."


    return "";
  }

  // const getGenerateButtonTooltipText = (usinaHasPermission: boolean | null | undefined, usinaId: string): React.ReactNode => {

  //   if (!usinaHasPermission) {
  //     return <>A usina não tem permissão para relatório mensal, <Box sx={{ cursor: "pointer", color: primary }} onClick={() => navigate(`/usinas/${usinaId}`)}>Clique aqui para alterar a permissão da usina</Box></>
  //   }

  //   if (relatorioMensalLoading) return "Aguarde a busca do relatório mensal."

  //   if (!reportDate) return "Selecione uma data para geração de relatório."

  //   return "";
  // }

  return (
    <Screen.Root
      sx={{
        padding: "20px",
        height: "100vh",
        display: "flex",
        overflow: "auto",
        alignContent: "center",
      }}
    >
      <Screen.Container removePadding sx={{ height: "100%" }}>
        <Grid
          container
          sx={{
            height: "100%",
            paddingBottom: "16px",
          }}
          spacing={2}
        >
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "20px",
              alignItems: "center",
              justifyContent: relatorioMensal ? undefined : "center",
            }}
          >
            <Box
              sx={{
                maxWidth: "400px",
                minWidth: { xs: "250px", md: "400px" },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Relatório Mensal
              </Typography>
              <DatePickerLocalizationAdapter>
                <DatePicker
                  format="MM/YYYY"
                  views={["month", "year"]}
                  value={reportMonthDate}
                  maxDate={today}
                  onChange={(date) => {
                    if (!date) return;
                    setReportMonthandYear({
                      month: date.month(),
                      year: date.year(),
                    });
                    setReportDate(date.format("YYYY-MM-DD"));
                  }}
                  label={"Mês referência"}
                  sx={{
                    width: "100%",
                    marginY: "12px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "4px",
                    },
                  }}
                />
              </DatePickerLocalizationAdapter>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Tooltip
                  title={
                    getExportButtonTooltipText(currentUsina?.reportOptions?.monthlyReportEnabled, currentUsina?.usinaIds.id)
                  }
                >
                  <Box
                    sx={{
                      width: "100%",
                      marginBottom: { xs: "8px", md: "0px" },
                    }}
                  >
                    <PrimaryBaseButton
                      disabled={isLoadingMonthlyReport || !reportDate || !currentUsina?.reportOptions?.monthlyReportEnabled}
                      sx={{ width: "100%" }}
                      loading={isLoadingMonthlyReport}
                      title="Buscar PDF"
                      onClick={handleGetMonthlyReport}
                    />
                  </Box>
                </Tooltip>
              </Box>
            </Box>
          </Grid>
          {relatorioMensal && (
            <>
              <Grid sx={{ width: "100%" }} item xs={12}>
                <Typography variant="h6" sx={{ paddingBottom: "20px" }}>
                  {`${selectedUsina?.name} ${getMonthName(
                    relatorioMensal.mesDeReferencia
                  )} de ${relatorioMensal.anoDeReferencia}`}
                </Typography>
              </Grid>
              {/* {reportErrors.map((error, i) => (
                <Grid key={i} sx={{ width: "100%" }} item xs={12}>
                  <Typography
                    sx={{
                      paddingBottom: "10px",
                      color: "#ff6060",
                      fontSize: 14,
                    }}
                  >
                    {error}
                  </Typography>
                </Grid>
              ))} */}
              <Grid sx={{ width: "100%" }} item xs={12}>
                <CardBox
                  dateLeft={`Dados do relatório coletados em: ${formatDateAndHour(
                    relatorioMensal.dataDeGeracao
                  )}`}
                  leftTopCalc={290}
                  widthTopCalc="305"
                  sx={{
                    height: "100%",
                    width: "100%",
                    paddingY: "32px",
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "16px",
                  }}
                >
                  <Box
                    sx={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        flexDirection: { xs: "column", md: "row" },
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      <UsinaDetailsInfo
                        title="Código da Usina: "
                        value={relatorioMensal.dadosUsina.cod}
                      />
                      <UsinaDetailsInfo
                        title="Número de Inversores: "
                        value={relatorioMensal.dadosUsina.numeroInversores}
                      />
                    </Box>
                    <Box
                      sx={{
                        flexDirection: { xs: "column", md: "row" },
                        display: "flex",
                        justifyContent: "space-around",
                      }}
                    >
                      <UsinaDetailsInfo
                        title="Potência Nominal: "
                        value={`${numberPtBr(
                          relatorioMensal.dadosUsina.potenciaMes / 1000,
                          1
                        )} MW`}
                      />
                      <UsinaDetailsInfo
                        title="Número de Módulos: "
                        value={relatorioMensal.dadosUsina.numeroModulos}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      flexDirection: { xs: "column", md: "row" },
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-around",
                    }}
                  >
                    <UsinaDetailsCard
                      title="PR Realizado"
                      value={numberPtBrPercent01(
                        relatorioMensal.compiladoUsinaMes.prReal
                      )}
                    />
                    <UsinaDetailsCard
                      title="Irradiação Realizada"
                      value={numberPtBrPercent01(
                        relatorioMensal.irradiacaoMediaRealizada
                      )}
                    />
                    <UsinaDetailsCard
                      title="Potência Média"
                      value={`${numberPtBr(
                        relatorioMensal.potenciaAtivaMensal
                      )} MW`}
                    />
                    <UsinaDetailsCard
                      title="Disponibilidade"
                      value={`${numberPtBr(
                        relatorioMensal.disponibilidadeMedia
                      )} %`}
                    />
                  </Box>
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <PRPerformedAndIrradiationChart />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <PerformanceTable />
              </Grid>

              <GeneratedEnergyCharts
                month={relatorioMensal.energiaGeradaInversoresMes.month}
                year={relatorioMensal.energiaGeradaInversoresMes.year}
                dias={relatorioMensal.energiaGeradaInversoresMes.dias}
                listaPerformanceUnidadeGeradora={
                  relatorioMensal.energiaGeradaInversoresMes
                    .listaPerformanceUnidadeGeradora
                }
                listaEnergiaGeradaInversor={
                  relatorioMensal.energiaGeradaInversoresMes
                    .listaEnergiaGeradaInversor
                }
                irradiacaoRealizadaDia={
                  relatorioMensal.energiaGeradaInversoresMes.irradiacaoRealizadaDia
                }
              />
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <InverterPerformanceCard
                    performanceInversores={
                      relatorioMensal.performanceInversores
                    }
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <UnitPerformanceChart
                    month={relatorioMensal.energiaGeradaInversoresMes.month}
                    year={relatorioMensal.energiaGeradaInversoresMes.year}
                    dias={relatorioMensal.energiaGeradaInversoresMes.dias}
                    listaPerformanceUnidadeGeradora={
                      relatorioMensal.energiaGeradaInversoresMes
                        .listaPerformanceUnidadeGeradora
                    }
                    listaEnergiaGeradaInversor={
                      relatorioMensal.energiaGeradaInversoresMes
                        .listaEnergiaGeradaInversor
                    }
                    irradiacaoRealizadaDia={
                      relatorioMensal.energiaGeradaInversoresMes
                        .irradiacaoRealizadaDia
                    }
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <ParetoReportChart
                    data={relatorioMensal.paretoDeOcorrenciasNoMes}
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <ParetoTable data={relatorioMensal.paretoDeOcorrenciasNoMes} />
              </Grid>
              <GeneratedParetoCharts />
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <ParetoReportChart
                    data={relatorioMensal.paretoDeOcorrenciaTrackersNoMes}
                    title="Pareto de ocorrências Trackers"
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <ParetoReportChart
                    data={relatorioMensal.paretoDeOcorrenciaComunicacaoNoMes}
                    title="Pareto de ocorrências falha de comunicação"
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <ExpectedAndGeneratedValueChart
                    valorEsperado={
                      relatorioMensal.compiladoUsinaMes.valorEsperado
                    }
                    valorGerado={relatorioMensal.compiladoUsinaMes.valorGerado}
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <GenerationComparisonChart
                    hasIdeal
                    energiaIdeal={
                      relatorioMensal.compiladoUsinaMes.energiaIdeal
                    }
                    energiaPrevista={
                      relatorioMensal.compiladoUsinaMes.energiaPrevista
                    }
                    energiaGerada={
                      relatorioMensal.compiladoUsinaMes.energiaGerada
                    }
                    prReal={relatorioMensal.compiladoUsinaMes.prReal}
                    prPrevisto={relatorioMensal.compiladoUsinaMes.prPrevisto}
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <PerformanceRatioChart
                    prReal={relatorioMensal.compiladoUsinaMes.prReal}
                    prPrevisto={relatorioMensal.compiladoUsinaMes.prPrevisto}
                  />
                </CardBox>
              </Grid>
              <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                <CardBox
                  sx={{
                    height: "100%",
                    width: "100%",
                    minHeight: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <LossDiagramReportChart
                    perdas={relatorioMensal.compiladoUsinaMes.perdasMes}
                  />
                </CardBox>
              </Grid>
              {relatorioMensal.plantaMTTRMTBF?.uGs.map((ug) => (
                <>
                  <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                    <CardBox
                      sx={{
                        height: "100%",
                        width: "100%",
                        minHeight: "400px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <MTTRAndMTBFChart
                        data={ug.inversores}
                        isMTTR
                        ugName={ug.name}
                      />
                    </CardBox>
                  </Grid>
                  <Grid sx={{ width: "100%" }} item xs={12} md={6}>
                    <CardBox
                      sx={{
                        height: "100%",
                        width: "100%",
                        minHeight: "400px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <MTTRAndMTBFChart
                        data={ug.inversores}
                        isMTTR={false}
                        ugName={ug.name}
                      />
                    </CardBox>
                  </Grid>
                </>
              ))}
              <GeneratedAvailabilityCharts
                disponibilidade={relatorioMensal.disponibilidadeMediaInversores}
              />
            </>
          )}
        </Grid>
      </Screen.Container>
      <ErrorModal
        contentText={errorModalData.message}
        open={showErrorModal}
        setOpen={closeErrorModal}
        title={errorModalData.title}
      />
    </Screen.Root>
  );
}
